import React, {Component} from 'react'
import { api } from "../../../../api/index"
import { connect } from 'react-redux'
import {app} from "../../../../config/constants";

class PromotionVariantComponent extends Component {
	constructor( props ) {
		super(props);

		this.handleActive = this.handleActive.bind(this);
	}

	removeVariation(periodKey, variantKey, variant, event) {
		event.preventDefault();

		api.promotions.removeVariation(periodKey, variantKey).then( () => {
			api.variants.deletePeriodVariant(variant);
		});
	}

	handleActive(isActive) {
		api.promotions.handlePositionFieldState( 'active', isActive, this.props.periodKey, this.props.variantkey );
	}

	render() {

		const key = Object.keys( api.promotions.types ).find( ( key ) => {
			return api.promotions.types[key].value === this.props.promotion.position;
		} );

		const TypeComponent = api.promotions.types[ key ].components.variant;

		let typeComponent = '';

		if ( false !== TypeComponent ) {
			typeComponent = <TypeComponent handleActive={this.handleActive} removeVariation={this.removeVariation} periodKey={this.props.periodKey} variantKey={this.props.variantkey} />
		}

		return (
			<div className="medium-12 cell">
				<div className="grid-x grid-margin-x grid-padding-y">
					{typeComponent}
				</div>
			</div>

		)
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	};
};

export default connect(mapStateToProps)(PromotionVariantComponent);



// WEBPACK FOOTER //
// ./src/application/components/promotions/parts/variant.js